export enum REWARD_TYPE {
	FREEBET = 'freebet',
	MONEY_BONUS = 'money_bonus',
	FREESPINS = 'freespins',
	TOURNAMENT_POINTS = 'tournament_points',
	XP_POINTS = 'xp_points',
	PHYSICAL_PRIZES = 'physical_prizes',
	PM_POINTS = 'pm_points',
	OTHER = 'other'
}

export enum DAILY_REWARD_STATUS {
	MISSED = 'missed',
	IN_PROGRESS = 'in_progress',
	FINISHED = 'finished',
	INITIAL = 'initial'
}

export enum GIFT_QUALITY {
	COMMON = 'common',
	RARE = 'rare',
	EPIC = 'epic',
	LEGENDARY = 'legendary'
}

export type DailyReward = {
	id: string;
	name: string;
	description: string;
	reward_type: REWARD_TYPE;
	amount: number | string;
	currency: string;
	image_url: string;
};

export type DailyRewardData = {
	id: string;
	date: string;
	closed_reward_image_url: string;
	reward_image_url: string;
	quality: GIFT_QUALITY | null;
	status: DAILY_REWARD_STATUS;
	seconds_to_date: number;
	extra_reward: boolean;
	reward: DailyReward;
};

export type DailyRewardReturnType = {
	id: string;
	name: string;
	background_image_url: string;
	date_end: string | null;
	date_start: string | null;
	format_type: 'default';
	user_daily_reward_days: DailyRewardData[];
};
